// Adapted from https://github.com/rackt/react-modal

import findTabbable from "util/tabbable";

export default function(node, e) {
    let tabbable = findTabbable(node);
    let finalTabbable = tabbable[e.shiftKey ? 0 : tabbable.length - 1];
    let leavingFinalTabbable = (
        finalTabbable === document.activeElement ||
        // handle immediate shift+tab after opening with mouse
        node === document.activeElement
    );
    if (!leavingFinalTabbable) {
        return;
    }
    e.preventDefault();
    let target = tabbable[e.shiftKey ? tabbable.length - 1 : 0];
    if (target) {
        target.focus();
    }
}
